// extracted by mini-css-extract-plugin
export default {"emailRegDrawer":"MobileRegistrationOptions--emailRegDrawer--iNp-b","drawerHeader":"MobileRegistrationOptions--drawerHeader--HVfQV"};